import type { ReactElement } from "react";
import type { IOption } from "./DropdownOption";
import { DropdownOptionLabelBlock } from "./DropdownOption";
import { dropdownMenuOptionRowHandlers } from "./dropdownMenuOptionRowHandlers";
import classes from "./classes.module.scss";

type IProps = {
	options: IOption[];
	isActive: (option: IOption) => boolean;
	handleSelect: (option: IOption) => void;
	menuId?: string;
	listboxName: string;
};

export function DropdownMenuListbox(props: IProps): ReactElement {
	const { options, isActive, handleSelect, menuId, listboxName } = props;
	return (
		<div className={classes["content"]} role="listbox" id={menuId} aria-label={listboxName}>
			{options.map((option) => {
				const active = isActive(option);
				const ns = !!option.notSelectable;
				const label = <DropdownOptionLabelBlock option={option} isActive={active} />;
				const rowBase = dropdownMenuOptionRowHandlers(option, ns, handleSelect);
				if (ns && active) {
					return (
						<div key={option.id} role="option" aria-selected="true" aria-disabled="true" data-not-selectable={ns} {...rowBase}>
							{label}
						</div>
					);
				}
				if (ns && !active) {
					return (
						<div key={option.id} role="option" aria-selected="false" aria-disabled="true" data-not-selectable={ns} {...rowBase}>
							{label}
						</div>
					);
				}
				if (active) {
					return (
						<div key={option.id} role="option" aria-selected="true" aria-disabled="false" data-not-selectable={ns} {...rowBase}>
							{label}
						</div>
					);
				}
				return (
					<div key={option.id} role="option" aria-selected="false" aria-disabled="false" data-not-selectable={ns} {...rowBase}>
						{label}
					</div>
				);
			})}
		</div>
	);
}
